<template>
  <v-tooltip bottom color="primary" v-if="showTooltip">
    <template v-slot:activator="{ on }">
      <v-icon v-on="on" color="primary">
        mdi-information-outline
      </v-icon>
    </template>
    <span>
        {{ $t("activate_tooltip", { model: model }) }}
    </span>
  </v-tooltip>
</template>

<script>
import { activationStore } from "@/utils/helpers";
import { getUserRole } from "@/services/AuthService";

export default {
  name: "ActivationToolTip",
  props: {
    model: {
      type: String,
      default: "",
    },
  },
  setup() {
    return { activationStore }
  },
  computed: {
    showTooltip() {
      const role = getUserRole();
      if (role === 0 || role === 3 || role === 4 || role === 5) {
        return false;
      }
      return !this.activationStore.isActivated;
    }
  }
};
</script>
